import React from "react";

import styles from "../../PersonalDataPolicy/Info/Info.module.scss";
import PreviousPage from "../../../partials/PreviousPage/PreviousPage";
import { Link } from "react-router";
import { SELLER } from "../../../../config/legal";

const Info: React.FC = () => {
  return (
    <section className={styles.info}>
      <div className="container">
        <PreviousPage currentPage="Политика конфиденциальности" title="Политика конфиденциальности" />
        <p className={styles.text}>
          Настоящая Политика конфиденциальности определяет порядок обращения Оператора с информацией, которую пользователь
          предоставляет или которая становится известна Оператору при использовании сайта {SELLER.site}.
        </p>
        <ul className={styles.list}>
          <ol>
            Оператор: {SELLER.name}, ИНН {SELLER.inn}, ОГРНИП {SELLER.ogrnip} (выдан {SELLER.ogrnipIssued}), юридический адрес:{" "}
            {SELLER.address}.
          </ol>
          <ol>
            Политика применяется вместе с <Link to="/policy">Политикой обработки персональных данных</Link>. В части персональных
            данных приоритет имеет Политика обработки персональных данных.
          </ol>

          <h3>1. Правовая основа</h3>
          <ol>
            1.1. Политика составлена с учётом Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных», Федерального
            закона от 27.07.2006 № 149-ФЗ «Об информации, информационных технологиях и о защите информации», Закона РФ от
            07.02.1992 № 2300-1 «О защите прав потребителей» и Гражданского кодекса Российской Федерации.
          </ol>
          <ol>
            1.2. Обработка персональных данных граждан Российской Федерации с использованием баз данных ведётся на территории
            Российской Федерации.
          </ol>

          <h3>2. Общие правила</h3>
          <ol>2.1. Пользование сайтом означает, что пользователь ознакомился с настоящей Политикой.</ol>
          <ol>
            2.2. Согласие на обработку персональных данных даётся отдельно, активной отметкой в чекбоксе и отправкой формы. Оно не
            считается данным из-за одного факта посещения сайта и не проставляется заранее.
          </ol>
          <ol>
            2.3. Согласие на аналитические cookie даётся кнопкой «Принять». До этого сервисы веб-аналитики не подключаются. Кнопка
            «Отказаться» означает отказ от аналитических cookie, сайт продолжает работать.
          </ol>
          <ol>2.4. Политика действует только для сайта {SELLER.site}.</ol>

          <h3>3. Какие сведения могут обрабатываться</h3>
          <ol>
            3.1. Сведения из форм: фамилия, имя, отчество, телефон, адрес электронной почты, адрес доставки, а также сведения,
            которые пользователь сам вносит в анкету дизайнера, заявку на образцы или сообщение.
          </ol>
          <ol>
            3.2. После согласия на аналитические cookie: IP-адрес, cookie, сведения о браузере, дата и время доступа, адрес
            страницы и предыдущей страницы, сведения о действиях на сайте.
          </ol>
          <ol>3.3. Оператор не продаёт персональные данные.</ol>

          <h3>4. Цели</h3>
          <ol>
            Сведения используются для оформления заказа, идентификации пользователя, обратной связи, уведомлений, клиентской
            поддержки, приёма платежей, рассмотрения анкет и заявок. Улучшение сайта по данным аналитики и рекламные сообщения
            возможны только после отдельного согласия.
          </ol>

          <h3>5. Cookies</h3>
          <ol>5.1. Сайт может использовать необходимые cookie для работы страниц и, при согласии, аналитические cookie.</ol>
          <ol>
            5.2. Пользователь может ограничить cookie в браузере. Отключение cookie может затруднить вход в разделы, требующие
            авторизации.
          </ol>

          <h3>6. Сроки и передача</h3>
          <ol>
            6.1. Сведения хранятся не дольше, чем нужно для целей обработки, либо до отзыва согласия, если закон не требует иного.
            Данные договора хранятся в течение срока договора и 5 лет после года его исполнения. Данные учётной записи – до
            удаления или отзыва согласия. Данные анкет – до исполнения заявки и 3 лет после этого либо до отзыва согласия.
          </ol>
          <ol>
            6.2. Передача возможна службам доставки и связи для исполнения заказа, АО «ТБанк» для проведения платежа и
            уполномоченным государственным органам по закону.
          </ol>

          <h3>7. Права пользователя</h3>
          <ol>
            Пользователь вправе получить сведения о своих данных, потребовать их уточнения, блокирования или удаления, отозвать
            согласие и обжаловать действия Оператора. Запрос направляется по адресу: {SELLER.address}.
          </ol>

          <h3>8. Изменение Политики</h3>
          <ol>
            Оператор вправе изменить Политику. Новая редакция действует с момента размещения на {SELLER.site}. Вопросы:{" "}
            {SELLER.shortName}, {SELLER.address}.
          </ol>
        </ul>
      </div>
    </section>
  );
};

export default Info;
